// Module
var code = "<div class=\"widget-content relative\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> </div>";
// Exports
module.exports = code;